module.exports = __webpack_public_path__ + "img/instagram.d19de3f5.png";